import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SidebarRightComponent } from './sidebar-right.component';
export class SidebarRightModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    exports: [SidebarRightComponent],
    declarations: [SidebarRightComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SidebarRightModule_tsickle_Closure_declarations() {
/** @type {?} */
SidebarRightModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SidebarRightModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
